import { Text, View } from 'react-native'
import React, { Component } from 'react'
import { SForm, SPage, SView } from 'servisofts-component'
import Container from '../../../Components/Container'

export default class nuevotutorial extends Component {
  render() {
    return (
      <SPage title="Nuevo Tutorial">
        <Container>
          <SForm
            inputs={{
                "video": {
                    label: "Video",
                    type: "file",
                    isRequired: true,
                },
                "nombre":{
                    label: "Titulo del video",
                    type: "text",
                    isRequired: true,
                },
                "musculo":{
                    label: "Musculo",
                    type: "select", 
                    isRequired: true,
                    options: [
                        { key: "pecho", content: "Pecho" },
                        { key: "espalda", content: "Espalda" },
                        { key: "Cuadriceps", content: "Cuadriceps" },
                        { key: "femoral", content: "Femoral" },
                        { key: "pantorrilla", content: "Pantorrilla" },
                        { key: "abdominales", content: "Abdominales" },
                        { key: "trapecio", content: "Trapecio" },
                        { key: "biceps", content: "Biceps" },
                        { key: "triceps", content: "Triceps" },
                        { key: "antebrazo", content: "Antebrazo" },
                        { key: "gluteos", content: "Gluteos" },
                        { key: "abductores", content: "Abductores" },
                        { key: "hombro", content: "Hombro" },
                    ]
                },
                "descripcion":{
                    label: "Descripcion",
                    type: "text",
                    isRequired: true,
                },
            }}

            onSubmit={(values) => {
              console.log(values);
              // Aquí puedes manejar el envío del formulario, como hacer una llamada a la API
              // para guardar los datos en la base de datos.
              // Por ejemplo:
              // fetch('https://tu-api.com/tutoriales', {
              this.state.data.push(values);
              this.setState({ data:this.state.data });
            }}

            onSubmitName={"Guardar"}
          />
        </Container>
      </SPage>
    )
  }
}